export default "__VITE_ASSET__Bf73lvgZ__"